import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DrawMap from './draw-map.vue';
import DrawListData from './draw-list-data.vue';
import { zoneList, mapQuery } from '@blade-sxp/task-management/api/statistics/index';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import { isEmpty } from 'lodash';
import { FictitiousMapModule } from '@blade-sxp/task-management/store/fictitiousMap';
import { ZoneTypeModule } from '@blade-sxp/task-management/store/zoneType';
import LoadMap from '@blade-sxp/task-management/components/virtual-area/load-map.vue';
import EntranceExitMark from '@blade-sxp/task-management/components/entrance-exit-mark/index.vue';
import UEHotMapList from '@blade-sxp/task-management/components/virtual-area/ue-hot-map-list.vue';
const Service = {
    zoneList,
    mapQuery,
};
let VirtualArea = class VirtualArea extends Vue {
    regionId;
    disabled;
    zoneId;
    isTotalArea;
    entranceExitData;
    noUrl = require('@blade/common/assets/images/no-data/empty-img-gray.png');
    treeData = [];
    mapImageUrl = '';
    mapType = '';
    mapLoading = false;
    buttons = ['ellipse'];
    options = setCustomOptions('circle');
    mapName = this.$props.regionId || '';
    isParentId = false;
    mapDataLoading = false;
    isShowMap = false;
    mapLoadStatus = true;
    mainAngle = {
        camera: null,
        target: null,
    };
    get isMapName() {
        return this.mapName && this.mapName !== '';
    }
    get mapLoadType() {
        return this.mapType === '3D-Three.js';
    }
    get zoneTypeData() {
        return ZoneTypeModule.zoneTypeData;
    }
    get isBackEnd() {
        return this.mapType === '3D_UE';
    }
    onchangeZoneTypeData(val) {
        if (!isEmpty(val) && this.zoneId) {
            const data = this.zoneTypeData?.filter((item) => item.id === this.zoneId);
            this.isParentId = data[0].type === 'ENTIRE_ZONE';
            FictitiousMapModule.updataIsParentId(this.isParentId);
        }
    }
    onChangeZoneId(val) {
        if (val && !isEmpty(this.zoneTypeData)) {
            const data = this.zoneTypeData?.filter((item) => item.id === val);
            this.isParentId = data[0].type === 'ENTIRE_ZONE';
            FictitiousMapModule.updataIsParentId(this.isParentId);
        }
    }
    onChangeRegionId(val) {
        if (val) {
            this.mapDetailData(Number(val));
        }
    }
    created() {
        this.getTreeData();
    }
    beforeDestroy() {
        FictitiousMapModule.clearPaintData();
    }
    loadMapBtn() {
        this.mapLoadStatus = false;
    }
    getMapStatus(val) {
        this.mapDataLoading = val;
    }
    getTreeData() {
        Service.zoneList({}).then((res) => {
            if (!isEmpty(res)) {
                this.treeData = this.deepClearTrim([res]);
            }
            else {
                this.treeData = [];
            }
        });
    }
    treeChange(id) {
        this.$emit('update:regionId', id);
        this.clearEntranceExitPosition();
        FictitiousMapModule.clearPaintData();
        FictitiousMapModule.updataPaintState(false);
        FictitiousMapModule.updataHotMapStatus(false);
        FictitiousMapModule.clearUEHotMapData();
        FictitiousMapModule.updataSilderValue(10);
        FictitiousMapModule.updataUEStatus(false);
        this.mapLoadStatus = false;
    }
    mapDetailData(id) {
        this.mapLoading = true;
        if (this.mapType !== '3D_UE') {
            this.mapImageUrl = '';
            this.mapType = '';
        }
        Service.mapQuery(id)
            .then((res) => {
            if (!isEmpty(res)) {
                //
                this.mapType = res.mapType === '3D_UE' ? '3D_UE' : res.mapType;
                this.isShowMap = true;
                this.mapLoadStatus = res.mapType === '3D-Three.js';
                const { camera, target } = JSON.parse(res?.mapConfig || '{}')?.configJson || {};
                if (camera && target) {
                    this.mainAngle = {
                        camera: camera,
                        target: target,
                    };
                }
                if (this.mapType === '3D_UE') {
                    if (!res?.mapImageUrl || res?.mapImageUrl === '' || this.mapImageUrl === res?.mapImageUrl) {
                        return false;
                    }
                    this.mapImageUrl = res?.mapImageUrl;
                }
                else {
                    this.mapImageUrl = res?.mapImageUrl;
                }
            }
        })
            .finally(() => {
            this.mapLoading = false;
        });
    }
    deepClearTrim(tree) {
        const deep = (tree) => {
            return tree.map((item) => {
                return {
                    ...item,
                    children: item?.children && item?.children.length > 0 ? deep(item.children) : null,
                };
            });
        };
        return deep(tree);
    }
    changeMarkIcon() {
        this.$emit('update:entranceExitData', this.entranceExitData);
    }
    // 点击加载3D地图
    handleLoadMap() {
        this.isShowMap = true;
    }
    clearEntranceExitPosition() {
        if (!this.isTotalArea)
            return;
        const data = this.entranceExitData;
        for (let k in data) {
            const val = data[k];
            val?.list?.forEach((item) => {
                item.position = null;
            });
        }
        this.changeMarkIcon();
    }
};
__decorate([
    Prop({ default: '' })
], VirtualArea.prototype, "regionId", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], VirtualArea.prototype, "disabled", void 0);
__decorate([
    Prop()
], VirtualArea.prototype, "zoneId", void 0);
__decorate([
    Prop()
], VirtualArea.prototype, "isTotalArea", void 0);
__decorate([
    Prop()
], VirtualArea.prototype, "entranceExitData", void 0);
__decorate([
    Watch('zoneTypeData', { immediate: true, deep: true })
], VirtualArea.prototype, "onchangeZoneTypeData", null);
__decorate([
    Watch('zoneId', { immediate: true })
], VirtualArea.prototype, "onChangeZoneId", null);
__decorate([
    Watch('regionId', { immediate: true })
], VirtualArea.prototype, "onChangeRegionId", null);
VirtualArea = __decorate([
    Component({
        name: 'VirtualArea',
        components: {
            'st-draw-map': DrawMap,
            'st-draw-list-data': DrawListData,
            'load-map': LoadMap,
            EntranceExitMark,
            'ue-hot-map-list': UEHotMapList,
        },
        i18n: {
            messages: {
                zh: {
                    map: '地图',
                    virtualArea: '虚拟区域',
                    mapPlaceholder: '您可以选择一个地图并且绘制虚拟区域',
                    pleaseSelect: '请选择所需圈定区域的地图',
                },
                en: {
                    map: 'Map',
                    virtualArea: 'Virtual Area',
                    mapPlaceholder: 'You can select a map and darw virtual area',
                    pleaseSelect: 'please select the map to be delineated',
                },
            },
        },
    })
], VirtualArea);
export default VirtualArea;
